module.exports = __webpack_public_path__ + "static/img/c_crm54.993bb2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c_crm54.jpg
// module id = aHBF
// module chunks = 73